export default {"src":"/_next/static/media/ios_blue.7ff61837.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};